import { render, staticRenderFns } from "./_HlaVirtualCrossmatch.vue?vue&type=template&id=190295a0&"
import script from "./_HlaVirtualCrossmatch.vue?vue&type=script&lang=ts&"
export * from "./_HlaVirtualCrossmatch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "@/components/hla/_locales/_HlaVirtualCrossmatch.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fcomponents%2Fhla%2F_HlaVirtualCrossmatch.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports